import { FC, ForwardedRef, forwardRef, ReactNode, useRef, useState } from 'react';
import classNames from 'classnames';
import GenericDropDown from '../../../shared/common/GenericDropDown';

export interface LCDDProps {
    onOpenListener?: () => void;
    onCloseListener?: () => void;
    className?: string;
    buttonClassname?: string;
    label?: string | ReactNode;
    preventCloseDropdown?: boolean;
    children: ReactNode;
}
export const LCDD: FC<LCDDProps> = forwardRef(
    (
        {
            label = null,
            onOpenListener = () => {},
            onCloseListener = () => {},
            preventCloseDropdown = false,
            buttonClassname,
            className,
            children
        },
        ref: ForwardedRef<HTMLDivElement>
    ) => {
        const [showDropdown, setShowDropdown] = useState(false);
        const scrollInnerRef = useRef<HTMLDivElement>(null);

        function onOpen() {
            setShowDropdown(true);
            onOpenListener();
        }

        function onClose() {
            setShowDropdown(false);
            onCloseListener();
        }

        const buttonClasses = classNames('dropdown-button', 'no-transition', buttonClassname);

        return (
            <GenericDropDown
                onOpenListener={onOpen}
                onCloseListener={onClose}
                ref={ref}
                className={classNames('dropdown', 'fl-left', className)}
            >
                <a className={buttonClasses} data-toggle-dropdown="true">
                    {label}
                    <i className="material-icons normal">{showDropdown ? 'expand_less' : 'expand_more'}</i>
                </a>
                {showDropdown ? (
                    <div className="dropdown-list" data-close-dropdown={!preventCloseDropdown}>
                        <div className="dropdown-list-inner" ref={scrollInnerRef}>
                            {children}
                        </div>
                    </div>
                ) : null}
            </GenericDropDown>
        );
    }
);
